import Consumer from './consumer'
import UserInformation from './user_information'
import UserAddress from './user_address'

export default { Consumer, UserInformation, UserAddress }
